import { LOADING, getModelError, isModelLoading } from '../constants';
import { CubesService as KoobCubesService } from './koob';
import { CubesService as DsCubesService } from './ds';
import createService from './createService';
import CanIService from './CanIService';
export const AutoCubesServiceFactory = ({ useService, useServiceItselfWithCustomSubscription }, schema_name) => {
    'use no memo';
    const globalClaim = 'L koob.cubes';
    const localClaim = `L ${schema_name}.cubes`;
    const claims = schema_name ? [globalClaim, localClaim] : [globalClaim]; //                                      
    const canI = useServiceItselfWithCustomSubscription(CanIService, claims);
    if (claims.some(claim => canI.can(claim) === undefined)) { //                                                   
        canI.ensure(claims);
        return Object.assign([], { error: null, loading: true });
    }
    const globalCubes = canI.can(globalClaim) ? useService(KoobCubesService) : [];
    const localCubes = canI.can(localClaim) ? useService(DsCubesService, schema_name) : [];
    const error = getModelError(globalCubes) || getModelError(localCubes);
    if (error)
        return Object.assign([], { error, loading: false });
    if (isModelLoading(globalCubes) || isModelLoading(localCubes))
        return Object.assign([], { error: null, loading: true });
    return Object.assign([].concat(localCubes, globalCubes), { error: null, loading: false });
};
export const AutoCubesService = createService('AutoCubesService', AutoCubesServiceFactory);
export default AutoCubesService;
/* 
                                                            
                                                                                                                              
                                   
  
                                                    
  
                                                                  
                                                      
 */
export const AutoCubeService = createService('AutoCubeService', ({ useService }, schema_name, cubeId) => {
    const cubes = useService(AutoCubesService, schema_name);
    if (getModelError(cubes))
        return new Error(getModelError(cubes));
    if (isModelLoading(cubes))
        return LOADING;
    return cubes.find(c => c.id === cubeId || c.name === cubeId || c.guid === cubeId) ?? null;
});
